import React from "react";
import s from "./home.module.css";
import SearchBar from "./SearchBar/searchBar";
import { Link } from "react-router-dom";
import FilterActivities from "./Filters/filters";
import { getActivities, getCountries } from "../../redux/actions";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import Paginate from "../Paginado/paginado";
import Country from "../Country/country";
import Ordened from "./Orders/orders";
import Loading from "../Loading/loading";

export default function Homee() {
  const dispatch = useDispatch();

  const allCountries = useSelector((state) => state.countries);

  useEffect(() => {
    dispatch(getCountries());
    dispatch(getActivities());
  }, );

  const [currentPage, setCurrentPage] = useState(1);

  const [countriesPage] = useState(10);
 

  const lastCountrie = currentPage * countriesPage; // 10-20 etc
  const firstCountrie = lastCountrie - countriesPage; //   1-10


  const searchi = () => {
    if (typeof allCountries === "string") {
      return false;
    } else {
      return true;
    }
  };

  const currentCountries = allCountries.slice(firstCountrie, lastCountrie);

  const paginado = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  

  if (currentCountries.length === 0) {
    return (
      <div>        
        <Loading />
      </div>
    );
  }


  return (
    <div className={s.body}>
      {searchi() ? (
        <div>
          <SearchBar
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      ) : null}

      {searchi() ? (
        <div className={s.paginate}>
          <Paginate
            countriesPage={countriesPage}
            allCountries={allCountries.length}
            paginado={paginado}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      ) : null}

      {searchi() ? (
        <div className={s.contCreate}>
          <Link to="/createActivity">
            <button className={s.create}></button>
          </Link>
        </div>
      ) : null}

      {searchi() ? (
        <div className={s.ordenes}>
          <FilterActivities setCurrentPage={setCurrentPage} />
          <Ordened setCurrentPage={setCurrentPage} />
        </div>
      ) : null}

      <div className={s.container}>
        {currentCountries ? (
          currentCountries.map((e) => {
            return (
              <Country
                key={e.idApi}
                idApi={e.idApi}
                name={e.name}
                continent={e.continent}
                img={e.img}
                population={e.population}
              />
            );
          })
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
}
